export default __webpack_public_path__ + "images/f63b3dd9879a295f55aabbb77815a8a4-comedy_mobile-2.webp";